import rest from "@/utils/rest";
export default {
  GetReportInitData() {
    let link = "Report/GetUsedCodesInitData";
    return rest
      .channel(link, {
        method: "GET",
      })
      .then((response) => rest.promiseInterceptor(response));
  },

  GetReportData: (
    ServiceID,
    PolicyNumber,
    CarNumber,
    StartSendDate,
    EndSendDate,
    StartAppoveDate,
    EndAppoveDate,
    fordownload
  ) => {
    let params = "?";
    params += "PolicyNumber=" + (PolicyNumber ? PolicyNumber : "");
    params += "&CarNumber=" + (CarNumber ? CarNumber : "");
    params += "&ServiceID=" + (ServiceID ? ServiceID : "");
    params += "&StartSendDate=" + (StartSendDate ? StartSendDate : "");
    params += "&EndSendDate=" + (EndSendDate ? EndSendDate : "");
    params += "&StartAppoveDate=" + (StartAppoveDate ? StartAppoveDate : "");
    params += "&EndAppoveDate=" + (EndAppoveDate ? EndAppoveDate : "");
    params += "&ForDownload=" + (fordownload ? true : false);
    let link = "Report/GetUsedCodes" + params;
    return rest
      .channel(link, {
        method: "GET",
      })
      .then((response) => rest.promiseInterceptor(response));
  },
};
